var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { deepMap } from './lib';
import { defaultConfigs } from '../defaults';
export function handlesValue(_a) {
    var whitelistedFields = _a.whitelistedFields, privateFieldsFuzzy = _a.privateFieldsFuzzy;
    return function (value, key) {
        if (key) {
            var k_1 = key.toLowerCase();
            var isMasked = privateFieldsFuzzy.some(function (f) {
                return k_1.includes(f.toLowerCase()) &&
                    !whitelistedFields.includes(key.toString());
            });
            return isMasked ? '*' : value;
        }
        return value;
    };
}
/**
 * Given some options, returns a function that takes in some data, walks it
 * recursively and inspects each item's properties. If any scalar data contains
 * "private data" (defined by `config.privateFuzzyFields`), it will be
 * replaced with `*`.
 *
 * @example
 * const scrub = scrubber({
 *   privateFuzzyFields:  ['pass']
 * })
 *
 * scrub({ password: 'foo' })
 * // => { password: '*' }
 */
export function scrubber(options) {
    if (options === void 0) { options = {}; }
    var config = __assign(__assign({}, defaultConfigs), options);
    return function (data) { return deepMap(data, handlesValue(config)); };
}
//# sourceMappingURL=scrub.js.map